<script>
  import { Icon } from "svelte-icons-pack";
  import { BiSolidDollarCircle } from "svelte-icons-pack/bi";
  import { BiQuestionMark } from "svelte-icons-pack/bi";

  import Tooltip from "./Tooltip.svelte";
  import { LayerCake, Svg } from "layercake";
  import AxisX from "./AxisX.svelte";
  import AxisY from "./AxisY.svelte";
  import Line from "./Line.svelte";
  import { timeFormat } from "d3-time-format";

  export let netliqs;
</script>

<Tooltip title="Close all positions and buy the Lambo?">
  <h6>
    <Icon src={BiSolidDollarCircle} size="20" color="CornflowerBlue" />
    Net Liquidity ${netliqs[netliqs.length - 1]["usd_value"]
      .toFixed(2)
      .toLocaleString("en-US", {
        sytle: "currency",
        currency: "USD",
      })}
    <Icon src={BiQuestionMark} size="20" color="grey" />
  </h6>
</Tooltip>

<div class="chart-container">
  <LayerCake
    data={netliqs}
    x="timestamp"
    y="usd_value"
    gridlines={false}
    padding={{ top: 10, right: 10, bottom: 50, left: 50 }}
  >
    <Svg label="Net Liquidity">
      <AxisX gridlines="false" format={timeFormat("%b %d %H:%M")} />
      <AxisY format={(d) => `$${d.toLocaleString()}`} />
      <Line color="#f0c" />
    </Svg>
  </LayerCake>
</div>

<style>
  .chart-container {
    width: 100%;
    height: 400px;
  }
</style>
